export const SET_INNER_PAGE = "SET_INNER_PAGE";
